// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1052":"92c8bd2f","2409":"b41b10d2","4063":"47e1dbe7"}[chunkId] + ".chunk.css";
};